// test2202
(2202 && 0);
